import styled from 'styled-components';

import { Table } from 'features/common/components/Table';

export interface RowProps {
	padding?: string;
	height?: string;
	gridColumns: string;
	textAlign?: string;
}

export const Row = styled.tr<RowProps>`
	box-sizing: border-box;
	display: grid;
	grid-template-columns: ${({ gridColumns }) => gridColumns};
	padding: ${({ padding }) => padding || '0'};
	height: ${({ height }) => height || '48px'};
	text-align: ${({ textAlign }) => textAlign || 'left'};
	align-items: center;
`;

export const HeaderRow = styled(Row)`
	background-color: ${({ theme }) => theme.colors.lightGrey16};
`;

export const ColumnHeader = styled.div`
	color: ${({ theme }) => theme.colors.black};
	font-weight: 500;
	font-size: 14px;
	border: none;
`;

export const DataRow = styled(Row)`
	background-color: ${({ theme }) => theme.colors.whitePearl};
	border-bottom: 1px solid ${({ theme }) => theme.colors.grey2};

	td {
		padding: 12px 16px;
		font-size: 14px;
		border: none;
		color: ${({ theme }) => theme.colors.grey8};
	}
`;

export const TableContainer = styled.div`
	width: 100%;
	border: none;
	border-radius: 4px;
	overflow-x: auto;
	margin-top: 16px;

	table {
		border-collapse: collapse;
		width: 100%;
	}
`;

export const SearchContainer = styled.div`
	width: 100%;
	max-width: 300px;
	margin-bottom: 24px;
`;

const StickyActionCellBase = styled(Table.Cell)`
	position: sticky;
	right: 0;
	z-index: 2;
	align-self: stretch;
	display: flex;
	align-items: center;
	justify-content: center;
	box-shadow: -4px 0 6px -2px rgba(0, 0, 0, 0.08);
	&& {
		padding: 0 4px;
	}
`;

export const StickyActionHeaderCell = styled(StickyActionCellBase)`
	background-color: ${({ theme }) => theme.colors.lightGrey16};
`;

export const StickyActionCell = styled(StickyActionCellBase)`
	background-color: ${({ theme }) => theme.colors.whitePearl};
	justify-content: flex-end;
`;

export const ScrollControls = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 4px;
`;

export const ScrollChevronButton = styled.button`
	display: inline-flex;
	align-items: center;
	justify-content: center;
	width: 24px;
	height: 24px;
	padding: 0;
	background: transparent;
	border: none;
	border-radius: 4px;
	cursor: pointer;
	color: ${({ theme }) => theme.colors.grey8};
	transition: background 0.15s ease, color 0.15s ease, opacity 0.15s ease;

	&:hover:not(:disabled) {
		background: ${({ theme }) => theme.colors.grey19};
		color: ${({ theme }) => theme.colors.black};
	}

	&:disabled {
		opacity: 0.3;
		cursor: default;
	}

	svg {
		width: 18px;
		height: 18px;
	}
`;

export const DownloadButton = styled.button`
	background: transparent;
	border: 1.5px solid ${({ theme }) => theme.colors.grey6};
	color: ${({ theme }) => theme.colors.grey8};
	padding: 8px 24px;
	border-radius: 8px;
	cursor: pointer;
	font-size: 14px;
	font-weight: 500;
	transition: all 0.2s ease;

	&:hover {
		background: ${({ theme }) => theme.colors.grey15};
		border-color: ${({ theme }) => theme.colors.grey8};
	}
`;
